// @flow
export const DEADLINE_CLOCK_ICON_URL =
  'https://images.ctfassets.net/heg7gyzix6dq/3ROojmFivmEWeKcAMGi6w4/71d7d42559c75812f92c02cd4dd63aa0/stop_watch_fixed.svg';
